import { render, staticRenderFns } from "./Mpin.vue?vue&type=template&id=115a3b44"
import script from "./Mpin.vue?vue&type=script&lang=js"
export * from "./Mpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports